export function injectCssForProductFruitChecklistDarkMode() {
    const targetDiv = document.getElementById('product-fruit-checklist');
    const shadowRoot = targetDiv?.children[0]?.shadowRoot;

    if (shadowRoot) {
        const sheet = new CSSStyleSheet();
        const rules = [
            '.productfruits--checklist-panel-embedded { background-color: #1d1d1b; }',
            '.productfruits--checklist-panel-embedded .productfruits--checklist-panel-header { color: #fff; }',
            '.productfruits--checklist-panel-embedded .pf-chk-title { color: #fff; }',
            '.productfruits--checklist-panel-embedded .productfruits--checklist-panel-footer { background-color: #1d1d1b; }',
            '.productfruits--checklist-panel-embedded .pf-chk-progress-panel .pf-chk-progress-text { color: #fff; }',
            '.productfruits--checklist-panel-embedded .pf-chk-progress-panel .pf-chk-progressbar { background-color: #fff; }'
        ];

        rules.forEach((rule, index) => {
            sheet.insertRule(rule, index);
        });
        shadowRoot.adoptedStyleSheets = [sheet];
    }
}
